import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataPeserta = 'data-peserta-pelatihan';
const getModulPostTest = 'modul-soal-post-test/';
const importSoal = 'workshop-pelatihan/import-soal/';
const tambahSoal = 'modul-soal-post-test/soal'
const deleteSoal = 'modul-soal-post-test/soal/'
const ubahSoal = 'modul-soal-post-test/soal/'

class ModulPostTestService {
    getDataPeserta(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            idWorkshopPelatihan: idWorkshopPelatihan,
            status_pembayaran: "umum",
            filter: filter
        }
        return axios.get(
            API_URL + getDataPeserta,
            {
                params: data,
                headers: authHeader()
            });
    }

    deleteSoal(idDatModulSoal) {
        return axios.delete(
            API_URL + deleteSoal + idDatModulSoal,
        {
            headers: authHeader()
        }); 
    }

    getModulPostTest(idPelatihan) {
        return axios.get(
            API_URL + getModulPostTest + idPelatihan, {
            headers: authHeader()
        });
    }

    tambahSoal(formData) {
    
        return axios.post(
            API_URL + tambahSoal, formData, {
                headers: authHeader()
            }
        );
    }

    ubahSoal(formData) {

        return axios.put(
            API_URL + ubahSoal + formData.idDatModulSoal, formData, {
                headers: authHeader()
            }
        );
    }

    importSoal(formData) {
        var form = new FormData();
        form.append("idPelatihan", formData.idPelatihan);
        if (formData.files !== '') {
            form.append('files', formData.files);
        }
        form.append("durasi", formData.durasi);
        form.append("kkm", formData.kkm);
        form.append("statusRetake", formData.statusRetake);
        form.append("statusAktifPostTest", formData.statusAktifPostTest);

        return axios.put(
            API_URL + importSoal+formData.idPelatihan, form, {
                headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } 
            }
        );
    }

}

export default new ModulPostTestService();